import {ConfigObjectType, StateId} from '@wallaby-ui/core';
import * as React from 'react';

import styles from './FilterNode.less';
import FilterNodeContainer from './FilterNodeContainer';
import FilterNodeContent from './FilterNodeContent';
import {Filter} from 'src/js/lib/filtering';
import {
  FilterSchema,
  FilterNode as FilterNodeModel,
} from 'src/js/model/filters_config';

interface OwnProps {
  areChildrenClickable?: boolean;
  autocomplete: (input: any) => void;
  autocompleteSetValues?: (values: any) => void;
  changeFilter: (values: any) => void;
  config: ConfigObjectType;
  filteringStateId: StateId;
  filterAndSearchStateId: StateId;
  isClickable?: boolean;
  isFilterSelected: (filter: Filter) => void;
  isOpened?: boolean;
  level?: number;
  node: FilterNodeModel;
  parentName?: string;
  removeFilter: (filter: Filter) => void;
  schema: FilterSchema;
  searchServiceUrl: string;
  selectedAutocompleteValues?: any[];
  selectedFilter?: Filter;
  toggleOpened: () => void;
  filterFocused: any;
}

type Props = OwnProps;

export const MuiFilterNode: React.FC<Props> = (props) => {
  const {
    areChildrenClickable = false,
    config,
    filterAndSearchStateId,
    filteringStateId,
    isOpened = false,
    level = 0,
    node,
    parentName,
    schema,
    searchServiceUrl,
    autocomplete,
    autocompleteSetValues,
    changeFilter,
    isClickable = false,
    isFilterSelected,
    removeFilter,
    selectedAutocompleteValues,
    selectedFilter,
    toggleOpened,
    filterFocused,
  } = props;

  const renderChildren = () => {
    return node.getChildrenIds().map((filterId) =>
      schema.getFilter(filterId).getType() ? (
        <div>
          <FilterNodeContainer
            config={config}
            searchServiceUrl={searchServiceUrl}
            filterAndSearchStateId={filterAndSearchStateId}
            filteringStateId={filteringStateId}
            node={schema.getFilter(filterId)}
            level={level + 1}
            schema={schema}
            isClickable={areChildrenClickable}
            parentName={parentName}
          />
        </div>
      ) : null
    );
  };

  return (
    <div className={styles.dlFilterNode} data-name={node.getName()}>
      <div>
        <FilterNodeContent
          areChildrenClickable={areChildrenClickable}
          autocomplete={autocomplete}
          autocompleteSetValues={autocompleteSetValues}
          config={config}
          filterFocused={filterFocused}
          isOpened={isOpened}
          toggleOpened={toggleOpened}
          node={node}
          changeFilter={changeFilter}
          removeFilter={removeFilter}
          parentName={parentName}
          isClickable={isClickable}
          isFilterSelected={isFilterSelected}
          selectedFilter={selectedFilter}
          selectedAutocompleteValues={selectedAutocompleteValues}
          schema={schema}
          isMui
        />
      </div>
      {renderChildren()}
    </div>
  );
};

MuiFilterNode.displayName = 'MuiFilterNode';
